import React from 'react';
import Select from 'react-select';
import Slider from 'rc-slider';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import filterInputFactory from './FilterInputFactory';
import queryString from 'query-string';
import VariableFilters from './VariableFilters';

const Range = Slider.createSliderWithTooltip(Slider.Range);

export default class Filters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        name: "",
        keywords: "",
        sex: null,
        state_uid: null,
        distance: null,
        zip: "",
        age: [],
        job_title: null
      },
      mainFilter: null,
      modalShow: false,
      loading: false,
      siteConfigs: null,
      jobTitleFilter: null
    };
  }

  componentDidMount() {
    this.updateFiltersWithURL();
  }

  componentWillReceiveProps(props) {
    // Needed to update the state_uid selector when states are received.
    let updateFilters = this.props.states.length === 0 && props.states.length > 0;

    this.setState({
      loading: props.loading,
      mainFilter: props.mainFilter,
      siteConfigs: props.siteConfigs,
      jobTitleFilter: props.jobTitleFilter
    }, () => {
      if (updateFilters) {
        this.updateFiltersWithURL();
      }
    });
  }

  updateFiltersWithURL() {
    if (window.location.search) {
      let params = queryString.parse(window.location.search, { arrayFormat: "bracket" });
      let form = this.state.form;

      // Fixed Filters
      let numericParams = ["sex", "distance"];
      for (let key in numericParams) {
        if (numericParams.hasOwnProperty(key) && params[numericParams[key]]) {
          form[numericParams[key]] = parseInt(params[numericParams[key]]);
        }
      }

      let stringParams = ["name", "keywords", "zip"];
      for (let key in stringParams) {
        if (stringParams.hasOwnProperty(key) && params[stringParams[key]]) {
          form[stringParams[key]] = params[stringParams[key]];
        }
      }

      form.age = [];
      if (params.agefrom && params.ageto) {
        if (!this.state.siteConfigs || (params.agefrom >= this.state.siteConfigs.minage && params.ageto <= this.state.siteConfigs.maxage)) {
          form.age = [parseInt(params.agefrom), parseInt(params.ageto)];
        } else {
          form.age = [];
        }
      }

      form.state_uid = params.state_uid ? this.props.states.filter(item => params.state_uid.indexOf(item.value + "") > -1) : null;
      form.job_title = params.job_title && this.props.jobTitleFilter ? this.props.jobTitleFilter.options.filter(item => params.job_title.indexOf(item.value + "") > -1) : null;

      // Variable Filters
      for (let key in this.props.searchFilters) {
        if (this.props.searchFilters.hasOwnProperty(key)) {
          let section = this.props.searchFilters[key];
          for (let key2 in section.filters) {
            if (section.filters.hasOwnProperty(key2)) {
              let filter = section.filters[key2];
              switch (filter.type) {
                case "checkbox":
                  if (params[filter.name]) {
                    form[filter.name] = params[filter.name] === "true";
                  }
                  break;
                case "slider":
                  if (params[filter.name + "to"] && params[filter.name + "from"]) {
                    form[filter.name] = [
                      parseInt(params[filter.name + "from"]),
                      parseInt(params[filter.name + "to"])
                    ];
                  }
                  break;
                case "select":
                  let filterName = this.isNumericString(filter.name) ? `items${filter.name}` : filter.name;
                  if (params[filterName]) {
                    form[filter.name] = filter.options.filter(item => params[filterName].indexOf(item.value + "") > -1);
                  }
                  break;
              }
            }
          }
        }
      }
      this.setState({ form });
    }
  }

  handleChange(fieldName, value) {
    let form = this.state.form;
    form[fieldName] = value;
    this.setState({ form });
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.handleSearch();
    }
  }

  fixedFilters() {
    return (
      <div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <div className="has-float-label">
                <input
                  id="name"
                  placeholder="Search by Name"
                  name="name"
                  type="text"
                  value={this.state.form.name}
                  onChange={event => this.handleChange("name", event.target.value)}
                  className="form-control"
                  onKeyPress={e => this.handleKeyPress(e)}
                />
                <label htmlFor="name">Search by Name</label>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <div className="has-float-label">
                <input
                  id="keywords"
                  placeholder="Search by Keywords"
                  name="name"
                  type="text"
                  value={this.state.form.keywords}
                  onChange={event => this.handleChange("keywords", event.target.value)}
                  className="form-control"
                  onKeyPress={e => this.handleKeyPress(e)}
                />
                <label htmlFor="keywords">Search by Keywords</label>
              </div>
            </div>
          </div>

          {this.state.siteConfigs && this.state.siteConfigs.profile_sex ? (
            <div className="col-md-4">
              <div className="form-group">
                <Select
                  name="sex"
                  value={this.state.form.sex}
                  options={[
                    { label: "Any Gender", value: null },
                    { label: "Male", value: 1 },
                    { label: "Female", value: 0 }
                  ]}
                  onChange={val => this.handleChange("sex", val.value)}
                  resetValue={{ label: "Any Gender", value: null }}
                  placeholder="Select Gender"
                  className="Select-bootstrap"
                />
              </div>
            </div>
          ) : null}

          <div className="col-md-4">
            <div className="form-group">
              <Select
                name="state_uid"
                placeholder="Filter by Location"
                multi
                joinValues
                value={this.state.form.state_uid}
                options={this.props.states}
                onChange={val => this.handleChange("state_uid", val)}
                className="Select-bootstrap"
              />
            </div>
          </div>

          {this.state.siteConfigs && this.state.siteConfigs.profile_agerange ? (
            <div className="col-md-4">
              <div className="form-group">
                <p className="slider-label">
                  Playing Age:{" "}
                  {this.state.form.age[1] ? `${this.state.form.age[0]}-${this.state.form.age[1]}` : `${this.state.siteConfigs.minage}-${this.state.siteConfigs.maxage}`}
                </p>
                <Range
                  min={this.state.siteConfigs.minage}
                  max={this.state.siteConfigs.maxage}
                  tipFormatter={value => `Playing Age: ${value}`}
                  value={this.state.form.age[1] ? this.state.form.age : [
                    this.state.siteConfigs.minage,
                    this.state.siteConfigs.maxage
                  ]}
                  onChange={val => this.handleChange("age", val)}
                />
              </div>
            </div>
          ) : null}

          <div className="col-md-4">
            <div className="form-group">
              <div className="input-group">
                <input style={{ height: 42 }}
                  type="number"
                  className="form-control"
                  placeholder={this.state.siteConfigs ? this.state.siteConfigs.distance : "miles"}
                  aria-describedby="basic-addon2"
                  value={this.state.form.distance ? this.state.form.distance : ""}
                  onChange={event => this.handleChange("distance", event.target.value)}
                  onKeyPress={e => this.handleKeyPress(e)}
                />
                <span className="pt-2 pl-1 pr-1">from</span>
                <input className="form-control col-sm-5" id="distance" placeholder="e.g. N1 1QP" value={this.state.form.zip} onChange={event => this.handleChange("zip", event.target.value)} onKeyPress={e => this.handleKeyPress(e)} />
              </div>
            </div>
          </div>

          {this.state.mainFilter ? (
            <div className="col-md-4">
              {filterInputFactory(this.state.mainFilter, val => this.handleChange(this.state.mainFilter.name, val), this.state.form[this.state.mainFilter.name])}
            </div>
          ) : null}

          {this.state.jobTitleFilter ? this.jobTitleFilter() : null}
        </div>
      </div>
    );
  }

  jobTitleFilter() {
    return (
      <div className="col-md-4">
        {filterInputFactory(this.state.jobTitleFilter, val => this.handleChange(this.state.jobTitleFilter.name, val), this.state.form[this.state.jobTitleFilter.name])}
      </div>
    );
  }

  toggle() {
    if (!this.state.loading) {
      this.setState({ modalShow: !this.state.modalShow });
    }
  }

  handleSearch() {
    if (this.props.handleSearch && !this.state.loading) {
      let filters = {};
      for (let key in this.state.form) {
        if (this.state.form.hasOwnProperty(key) && this.state.form[key] !== null && this.state.form[key] !== false) {
          if (typeof this.state.form[key] === "object") {
            if (typeof this.state.form[key][0] === "number") {
              // Range Slider
              filters[key + "from"] = this.state.form[key][0];
              filters[key + "to"] = this.state.form[key][1];
            } else {
              // Multi Select
              let newKey = key;
              // Add items to the keys if they are numeric. And yes, this seems to be the right way to determine if a string represents a numeric value in JS :(
              if (this.isNumericString(key)) {
                newKey = `items${key}`;
              }
              filters[newKey] = this.state.form[key].map(item => item.value);
            }
          } else {
            filters[key] = this.state.form[key];
          }
        }
      }
      if (filters && filters.distance && this.state.siteConfigs.distance === "km") {
        filters.distance = filters.distance * 0.621371;
      }
      if ((filters.distance && !filters.zip) || (filters.zip && !filters.distance)) {
        delete filters.distance;
        delete filters.zip;
      }
      this.props.handleSearch(filters);
    }
  }

  isNumericString(str) {
    return !isNaN(parseFloat(str)) && isFinite(str);
  }

  clearFilters() {
    this.setState({
      form: {
        name: "",
        keywords: "",
        sex: null,
        state_uid: null,
        distance: null,
        zip: "",
        age: [],
        job_title: null
      }
    }, () => this.handleSearch());
  }

  render() {
    return (
      <div>
        {this.props.children}
        {this.fixedFilters()}
        <hr />
        <VariableFilters handleChange={(fieldName, value) => this.handleChange(fieldName, value)} form={this.state.form} searchFilters={this.props.searchFilters} onlyActive={true} />
        <button type="button" className={"btn btn-secondary col-lg-2 col-md-3 mb-2 mr-3" + (this.state.loading ? " disabled" : "")} onClick={() => this.toggle()}>
          <i className="fa fa-sliders mr-3" aria-hidden="true" /> More filters
        </button>
        <button type="button" className={"btn btn-primary col-lg-2 col-md-3 mb-2 mr-3" + (this.state.loading ? " disabled" : "")} onClick={() => this.handleSearch()}>
          <i className="fa fa-search mr-3" aria-hidden="true" /> Search
        </button>
        <button type="button" className={"btn btn-warning col-lg-2 col-md-3 mb-2" + (this.state.loading ? " disabled" : "")} onClick={() => this.clearFilters()}>
          <i className="fa fa-trash mr-3" aria-hidden="true" /> Clear Filters
        </button>

        <Modal isOpen={this.state.modalShow} toggle={() => this.toggle()} className="modal-lg">
          <ModalHeader toggle={() => this.toggle()}>More Filters</ModalHeader>
          <ModalBody>
            <VariableFilters form={this.state.form} searchFilters={this.props.searchFilters} onlyActive={false}
              handleChange={(fieldName, value) =>
                this.handleChange(fieldName, value)
              }
            />
          </ModalBody>
          <ModalFooter>
            <button type="button" className="btn btn-primary"
              onClick={() => {
                this.toggle();
                this.handleSearch();
              }}>Apply Changes</button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
